import parseFraction from './parseFraction'

const calculateOdds = (betSelections) => {
    const odds = betSelections.reduce((total, bet) => {
        const decimal = parseFraction(bet.fractionalPrice);
        return total * (decimal + 1)
    }, 1) - 1

    return (odds < 1) ? 1 : odds
}

export default calculateOdds



// WEBPACK FOOTER //
// /src/js/common/utils/multiplesOdds.js